import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbButton from "../ui-kit/dfb_button"
import Section from "./section"
import { downloadUrlProxyfier } from "../../helper/downloadUrlProxyfier"

const MDownloadTeaser = (props) => {
  // "assets" and "kicker" are changed field names in the DFBde CMS
  const download = props.data.download || props.data.assets[0]
  const subheadline = props.data.subheadline || props.data.kicker

  if (!download || !download.src) {
    // do not render anything if no download url is specified
    return null
  }
  const icon = props.data.icon
    ? props.data.icon.replace(/^dfb-icon-/, "")
    : "download"

  const fileSize = download.size
    ? (download.size / 1024 / 1024).toFixed(1).replace(".", ",") + " MB"
    : ""

  return (
    <Section
      baseClass="m-DownloadTeaser"
      className={props.data.bg_color}
      defaultPaddingTop="large"
      data={props.data}
    >
      <div className="m-DownloadTeaser-wrapper">
        <div className="m-DownloadTeaser-container">
          <div className="m-DownloadTeaser-info">
            <div className="m-DownloadTeaser-topline">
              {subheadline}
            </div>
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h3"
              add_class="u-Theme-dark m-DownloadTeaser-headline"
            />
            <div className="dfb-Rte u-Theme-dark m-DownloadTeaser-teaserText">
              <p>
                <strong>{props.data.text}</strong>
              </p>
            </div>
          </div>
          <div className="m-DownloadTeaser-download">
            <div className="m-DownloadTeaser-downloadInner">
              <DfbIcon
                icon_type={icon}
                add_class="m-DownloadTeaser-icon"
                tagName="div"
              />
              <div className="m-DownloadTeaser-buttonWrapper">
                {/*
                  TODO: We use two different buttons. Instead, we should invert them using CSS.
                */}
                <DfbButton
                  tagName="a"
                  add_class="m-DownloadTeaser-button m-DownloadTeaser-button--light"
                  text={props.data.link_text}
                  link={downloadUrlProxyfier(download.src)}
                />
                <DfbButton
                  tagName="a"
                  add_class="m-DownloadTeaser-button m-DownloadTeaser-button--dark u-Theme-dark"
                  text={props.data.link_text}
                  link={downloadUrlProxyfier(download.src)}
                />
              </div>
              <div className="m-DownloadTeaser-fileInfo">
                <DfbHeadline
                  headline={download.title}
                  headline_level="h5"
                  add_class="m-DownloadTeaser-fileName"
                />
                <div className="m-DownloadTeaser-fileDetails">
                  {download.extension} {fileSize}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="m-DownloadTeaser-playground" />
    </Section>
  )
}

export default MDownloadTeaser
